import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import AppNavbar from "../components/AppNavbar";
import SideMenu from "../components/SideMenu";
import AppTheme from "../shared-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../theme/customizations";
import { SelectedObjectProvider } from "../contexts/SelectedObjectContext";
import PageErrorBoundary from "../components/PageErrorBoundary";
import VendaiSaleTables from "./dashboard/VendaiSaleTables";
import ObjectDetails from "./dashboard/ObjectDetails";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard2(props) {
  return (
    <SelectedObjectProvider>
      <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: "flex" }}>
          <SideMenu />
          <AppNavbar />
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: "auto",
            })}
          >
            <PageErrorBoundary>
              <Stack
                spacing={2}
                sx={{
                  alignItems: "center",
                  mx: 3,
                  pb: 5,
                  mt: { xs: 8, md: 0 },
                  pt: { xs: 2, md: 4 },
                }}
              >
                {/* Yeni: VendaiTimePeriodSaleTable/3 ile beslenen Toplam Satış + Satış Adeti */}
                <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
                  <Chip
                    label="YENİ"
                    color="success"
                    size="small"
                    sx={{ mb: 1, fontWeight: 700 }}
                  />
                  <VendaiSaleTables periodId={3} />
                </Box>

                {/* Test/karşılaştırma: eski datadan (projectDashboardWidgetJson) gelen tablolar */}
                <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
                  <Chip
                    label="ESKİ"
                    color="default"
                    size="small"
                    sx={{ mb: 1, fontWeight: 700 }}
                  />
                  <ObjectDetails excludeWidgetKeys={["Son Satışlar", "latestSales"]} />
                </Box>
              </Stack>
            </PageErrorBoundary>
          </Box>
        </Box>
      </AppTheme>
    </SelectedObjectProvider>
  );
}
